export default __webpack_public_path__ + "static/blob-660fef42c186cbe716902655da7bca09.webp";